module.exports = "<div id=\"{{ $ctrl.lineChartId }}\"></div>";